import { faqSectionData } from './faqSectionData';
export { faqSectionData };
